<template>
  <v-toolbar id="supheader" dense flat>
    <v-toolbar-title>
      <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
    </v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    pageId: String,
    name: String,
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "Database",
          to: { name: "database" },
        },
        {
          text: "Program pages",
          to: { name: "database_view", params: { view: "program_pages", sub: "ALL" } },
        },
        {
          text: this.name || "New page",
        },
      ];
    },
  },
};
</script>
